export const updateUser = (payload?: any) => ({
    type: "@saga/UPDATE_USER",
    payload
});

